import { cn } from "@/lib/utils";

type SectionHeadingProps = {
  eyebrow?: string;
  eyebrowClassName?: string;
  title: string;
  description?: string;
  titleAs?: "h1" | "h2";
  fullWidth?: boolean;
  align?: "left" | "center";
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
};

const eyebrowStyles =
  "hero-gradient-text uppercase tracking-[0.12em] font-semibold";

export default function SectionHeading({
  eyebrow,
  eyebrowClassName,
  title,
  description,
  titleAs = "h2",
  fullWidth = false,
  align = "left",
  className,
  titleClassName,
  descriptionClassName,
}: SectionHeadingProps) {
  const TitleTag = titleAs;

  return (
    <div
      className={cn(
        !fullWidth && "max-w-3xl",
        align === "center" && "mx-auto text-center",
        className,
      )}
    >
      {eyebrow ? (
        <p
          className={cn(
            "mb-1.5 text-[13px] text-muted-foreground",
            eyebrowStyles,
            eyebrowClassName,
          )}
        >
          {eyebrow}
        </p>
      ) : null}
      <TitleTag
        className={cn(
          "font-heading text-balance text-[clamp(1.75rem,3vw,2.5rem)] font-semibold leading-[1.22] tracking-[-0.03em] text-foreground",
          titleClassName,
        )}
      >
        {title}
      </TitleTag>
      {description ? (
        <p
          className={cn(
            "mt-3 text-base leading-7 text-muted-foreground md:text-[17px]",
            !fullWidth && "max-w-[65ch]",
            descriptionClassName,
          )}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}
